apex-chart {
  display: block;
  width: 100%;
  height: auto;
}

.apex-chart-container {
  width: 100%;
  height: 100%;
}